import { getWindow } from 'ssr-window'

const window = getWindow();

const TEST_KEY = '__test';
let _sessionStorage = null;

export const localStorage = window.localStorage;

const _hasStorage = (name: 'sessionStorage' | 'localStorage') => {
	try {
		const storage = window[name];
		storage.setItem(TEST_KEY, '1');
		storage.removeItem(TEST_KEY);
		return true;
	} catch (e) {
		return false;
	}
};

const isSessionStorageSupported = () => _hasStorage('sessionStorage');

if (isSessionStorageSupported()) {
	// use sessionStorage
	_sessionStorage = window.sessionStorage;
} else {
	_sessionStorage = window.localStorage;
}

export const sessionStorage = _sessionStorage;
